import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "production/process-flow"

class service {

    selectList(params) {

        return http.list(path + "/selectList", params);

    }

    findApplicableByProductId(productId){

        return http.list(path + "/findApplicableByProductId/"+productId);

    }

}

export default new service();


